export default __webpack_public_path__ + "src/archives/start-4245d7.png";